import React, { useState } from 'react';
import EventsInput from './EventsInput';
import EventsOutput from './EventsOutput';
import GalleryInput from './GalleryInput';
import GalleryOutput from './GalleryOutput';
import MagazineInput from './MagazineInput';
import MagazineOutput from './MagazineOutput';
import FrontApp from './json-src/App';
import Objective from './json-src/Objective.jsx';
import Area from './json-src/Area.jsx';
import History from './json-src/History.jsx';
import Awards from './json-src/Awards.jsx';
import Home from './json-src/Home.jsx';
import Footer from './json-src/Footer.jsx';
import Program from './ProgrammesOutput.jsx'
import Contact from './json-src/Contact.jsx';
import Know from './json-src/Know.jsx';
import Navbar from './json-src/Navbar.jsx';
import ProgrammesInput from './ProgrammesInput.jsx';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  const [events, setEvents] = useState([]);
  const [programmes, setProgrammes] = useState([]); // State for programmes

  const addEvent = (newEvent) => {
    setEvents([...events, newEvent]);
  };

  const addProgramme = (newProgramme) => {
    setProgrammes([...programmes, newProgramme]);
  };

  return (
    <Router>
      <Navbar />
      <div>
        <Routes>
          <Route path="/addevent" element={<EventsInput addEvent={addEvent}/>}/>
          <Route path="/addprogramme" element={<ProgrammesInput addProgramme={addProgramme}/>}/> {/* Add new route */}
          <Route path="/history" element={<History />} />
          <Route path="/events" element={<EventsOutput events={events}/>}/>
          <Route path="/addgallery" element={<GalleryInput />}/>
          <Route path="/gallery" element={<GalleryOutput />}/>
          <Route path="/addmagazine" element={<MagazineInput />}/>
          <Route path="/magazine" element={<MagazineOutput />}/>
          <Route path="/program" element={<Program />}/>
          <Route path="/" element={<Home />} />
          <Route path="awards" element={<Awards />} />
          <Route path="/area" element={<Area />} />
          <Route path="/objective" element={<Objective />} />
          <Route path="contact" element={<Contact />} />
          <Route path="know" element={<Know />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;